<template>
    <DForm @submit.prevent="submitForm">
        <DCard
            :title="__('settings.sms_clients_settings.clients.budget_sms')"
            :padding="true"
            class="mb-4"
        >
            <DFormRow
                :label="__('settings.sms_clients_settings.form.communications_client_toggle')"
                :is-required="true"
                :hint="__('settings.sms_clients_settings.form.communications_client_toggle_hint')"
            >
                <DSwitch
                    v-model="form.budget_sms_enabled"
                    color="success"
                    variant="3d"
                    @update:modelValue="$emit(!form.budget_sms_enabled)"
                />
            </DFormRow>
            <DFormRow
                v-if="form.budget_sms_enabled"
                :label="__('settings.sms_clients_settings.form.api_url')"
                :is-required="true"
                :hint="__('settings.sms_clients_settings.form.api_url_hint')"
            >
                <DInput
                    id="api_url_budget"
                    v-model="form.api_url_budget"
                    :placeholder="__('settings.sms_clients_settings.form.api_url')"
                    :is-valid="isFormFieldValid('api_url_budget')"
                    :invalid-feedback="errors.api_url_budget"
                    type="text"
                />
            </DFormRow>
            <DFormRow
                v-if="form.budget_sms_enabled"
                :label="__('settings.sms_clients_settings.form.api_key')"
                :is-required="true"
                :hint="__('settings.sms_clients_settings.form.api_key_hint')"
            >
                <DInput
                    id="api_key_budget"
                    v-model="form.api_key_budget"
                    :placeholder="__('settings.sms_clients_settings.form.api_key')"
                    :is-valid="isFormFieldValid('api_key_budget')"
                    :invalid-feedback="errors.api_key_budget"
                    type="password"
                />
            </DFormRow>
            <DFormRow
                v-if="form.budget_sms_enabled"
                :label="__('settings.sms_clients_settings.form.api_user_name')"
                :is-required="true"
                :hint="__('settings.sms_clients_settings.form.api_user_name_hint')"
            >
                <DInput
                    id="api_user_name_budget"
                    v-model="form.api_user_name_budget"
                    :placeholder="__('settings.sms_clients_settings.form.api_user_name')"
                    :is-valid="isFormFieldValid('api_user_name_budget')"
                    :invalid-feedback="errors.api_user_name_budget"
                    type="text"
                />
            </DFormRow>
            <DFormRow
                v-if="form.budget_sms_enabled"
                :label="__('settings.sms_clients_settings.form.api_user_id')"
                :is-required="true"
                :hint="__('settings.sms_clients_settings.form.api_user_id_hint')"
            >
                <DInput
                    id="api_user_id_budget"
                    v-model="form.api_user_id_budget"
                    :placeholder="__('settings.sms_clients_settings.form.api_user_id')"
                    :is-valid="isFormFieldValid('api_user_id_budget')"
                    :invalid-feedback="errors.api_user_id_budget"
                    type="text"
                />
            </DFormRow>
            <DFormRow
                v-if="form.budget_sms_enabled"
                :label="__('settings.sms_clients_settings.form.api_sender_id')"
                :is-required="true"
                :hint="__('settings.sms_clients_settings.form.api_sender_id_hint')"
            >
                <DInput
                    id="api_sender_id_budget"
                    v-model="form.api_sender_id_budget"
                    :placeholder="__('settings.sms_clients_settings.form.api_sender_id')"
                    :is-valid="isFormFieldValid('api_sender_id_budget')"
                    :invalid-feedback="errors.api_user_id_budget"
                    type="text"
                />
            </DFormRow>
            <DFormRow
                v-if="form.budget_sms_enabled"
                :label="__('settings.sms_clients_settings.form.budget_sms_test_endpoint_enabled')"
                :is-required="true"
                :hint="__('settings.sms_clients_settings.form.budget_sms_test_endpoint_enabled_hint')"
            >
                <DSwitch
                    v-model="form.budget_sms_test_endpoint_enabled"
                    color="success"
                    variant="3d"
                />
            </DFormRow>
            <DRow
                v-if="form.budget_sms_enabled"
            >
                <DCol sm="4" />
                <DCol sm="4">
                    <div
                        v-if="connectionStatusBudgetSms === 'successful'"
                        class="green-text"
                    >
                        {{ __('settings.newsletter_settings.connection_successful') }}
                    </div>
                    <div
                        v-if="connectionStatusBudgetSms === 'unsuccessful'"
                        class="text-danger"
                    >
                        {{ __('settings.newsletter_settings.connection_unsuccessful') }}
                    </div>
                </DCol>
                <DCol
                    sm="4"
                    class="check-database-connection-btn"
                >
                    <DButton
                        icon="lan-connect"
                        :label="__('settings.newsletter_settings.check_connection')"
                        :disabled="isInLoadingState"
                        @click="checkConnection('budgetsms')"
                    />
                </DCol>
            </DRow>
        </DCard>

        <DCard
            :title="__('settings.sms_clients_settings.clients.telesign')"
            :padding="true"
        >
            <DFormRow
                :label="__('settings.sms_clients_settings.form.communications_client_toggle')"
                :is-required="true"
                :hint="__('settings.sms_clients_settings.form.communications_client_toggle_hint')"
            >
                <DSwitch
                    v-model="form.telesign_enabled"
                    color="success"
                    variant="3d"
                    @update:modelValue="$emit(!form.telesign_enabled)"
                />
            </DFormRow>
            <DFormRow
                v-if="form.telesign_enabled"
                :label="__('settings.sms_clients_settings.form.api_url')"
                :is-required="true"
                :hint="__('settings.sms_clients_settings.form.api_url_hint')"
            >
                <DInput
                    id="api_url_telesign"
                    v-model="form.api_url_telesign"
                    :placeholder="__('settings.sms_clients_settings.form.api_url')"
                    :is-valid="isFormFieldValid('api_url_telesign')"
                    :invalid-feedback="errors.api_url_telesign"
                    type="text"
                />
            </DFormRow>
            <DFormRow
                v-if="form.telesign_enabled"
                :label="__('settings.sms_clients_settings.form.api_key')"
                :is-required="true"
                :hint="__('settings.sms_clients_settings.form.api_key_hint')"
            >
                <DInput
                    id="api_key_telesign"
                    v-model="form.api_key_telesign"
                    :placeholder="__('settings.sms_clients_settings.form.api_key')"
                    :is-valid="isFormFieldValid('api_key_telesign')"
                    :invalid-feedback="errors.api_key_telesign"
                    type="password"
                />
            </DFormRow>
            <DFormRow
                v-if="form.telesign_enabled"
                :label="__('settings.sms_clients_settings.form.api_user_id')"
                :is-required="true"
                :hint="__('settings.sms_clients_settings.form.api_user_id_hint')"
            >
                <DInput
                    id="api_user_id_telesign"
                    v-model="form.api_user_id_telesign"
                    :placeholder="__('settings.sms_clients_settings.form.api_user_id')"
                    :is-valid="isFormFieldValid('api_user_id_telesign')"
                    :invalid-feedback="errors.api_user_id_telesign"
                    type="text"
                />
            </DFormRow>
            <DRow
                v-if="form.telesign_enabled"
            >
                <DCol sm="4" />
                <DCol sm="4">
                    <div
                        v-if="connectionStatusTelesign === 'successful'"
                        class="green-text"
                    >
                        {{ __('settings.newsletter_settings.connection_successful') }}
                    </div>
                    <div
                        v-if="connectionStatusTelesign === 'unsuccessful'"
                        class="text-danger"
                    >
                        {{ __('settings.newsletter_settings.connection_unsuccessful') }}
                    </div>
                </DCol>
                <DCol
                    sm="4"
                    class="check-database-connection-btn"
                >
                    <DButton
                        icon="lan-connect"
                        :label="__('settings.newsletter_settings.check_connection')"
                        :disabled="isInLoadingState"
                        @click="checkConnection('telesign')"
                    />
                </DCol>
            </DRow>
            <DFormControls
                :dirty="form.isDirty"
                @submit="submitForm"
            />
        </DCard>
    </DForm>
    <DConnectionErrorModal
        :show-modal="connectionException !== null"
        :exception="connectionException"
        @close-modal="closeModal"
    />
</template>

<script setup>
import { ref } from 'vue'
import { useForm } from '@inertiajs/vue3'
import { route } from '~@/Composables/route'

import DConnectionErrorModal from '~@/Components/Common/DConnectionErrorModal'

const props = defineProps({
    smsClientsSettings: {
        type: Object,
        default: () => ({})
    },
    errors: {
        type: Object,
        default: () => ({})
    }
})

const connectionStatusBudgetSms = ref(null)
const connectionStatusTelesign = ref(null)
const connectionException = ref(null)
const emit = defineEmits(['form-submitted'])

const form = useForm({
    budget_sms_enabled: props.smsClientsSettings?.budget_sms_enabled ?? false,
    budget_sms_test_endpoint_enabled: props.smsClientsSettings?.budget_sms_test_endpoint_enabled,
    api_url_budget: props.smsClientsSettings?.api_url_budget ?? '',
    api_key_budget: props.smsClientsSettings?.api_key_budget ?? '',
    api_user_name_budget: props.smsClientsSettings?.api_user_name_budget ?? '',
    api_user_id_budget: props.smsClientsSettings?.api_user_id_budget ?? '',
    api_sender_id_budget: props.smsClientsSettings?.api_sender_id_budget ?? '',
    telesign_enabled: props.smsClientsSettings?.telesign_enabled ?? false,
    api_url_telesign: props.smsClientsSettings?.api_url_telesign ?? '',
    api_key_telesign: props.smsClientsSettings?.api_key_telesign ?? '',
    api_user_id_telesign: props.smsClientsSettings?.api_user_id_telesign ?? '',
    client: null
})

const submitForm = () => {
    emit('form-submitted', form)
}
const checkConnection = (client) => {
    connectionException.value = null
    form.client = client
    window.axios.post(route('settings.sms-clients-settings.check', form))
        .then(function () {
            if (client === 'budgetsms') {
                connectionStatusBudgetSms.value = 'successful'
            }
            if (client === 'telesign') {
                connectionStatusTelesign.value = 'successful'
            }
        })
        .catch(function (error) {
            if (client === 'budgetsms') {
                connectionStatusBudgetSms.value = 'unsuccessful'
            }
            if (client === 'telesign') {
                connectionStatusTelesign.value = 'unsuccessful'
            }
            if (error?.response.data.exception !== undefined) {
                connectionException.value = error.response.data.exception
            }
        }
        )
}

function closeModal () {
    connectionException.value = null
}
</script>

<style lang="scss" scoped>
    .green-text {
        color: green;
    }
</style>
